import en from "../en.json";
import th from "../th.json";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next.use(initReactI18next).init({
  lan: "en",
  resources: {
    en: {
      global: en,
    },
    th: {
      global: th,
    },
  },
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
